/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventLogFieldGroupList } from '../../models/event-log-field-group-list';
import { EventLogGroupName } from '../../models/event-log-group-name';
import { SortDirection } from '../../models/sort-direction';

export interface GetEventsLogGroups$Any$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * Indicates the field to use for grouping the data:
 *   * DATE : the date (truncated on day)
 *   * TAG : the tag name
 *   * DESCRIPTION : the tag description
 *   * VALUE : the value
 *   * GROUP : the tag group
 */
  groupName?: EventLogGroupName & any;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;
  
    /**
     * Body for search events log
     */
    body?: any
}

export function getEventsLogGroups$Any(http: HttpClient, rootUrl: string, params: GetEventsLogGroups$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<EventLogFieldGroupList>> {
  const rb = new RequestBuilder(rootUrl, getEventsLogGroups$Any.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('groupName', params.groupName, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EventLogFieldGroupList>;
    })
  );
}

getEventsLogGroups$Any.PATH = '/stations/{uid}/eventslog/group';
